export default __webpack_public_path__ + "static/media/team_photo1.png.webp";